import { HandUpStatus } from '@/pages/Meeting/component/EmoJ';
import { ReactionChangeChangeData } from '@/pages/Meeting/hooks/stompResponse/reactionChange';

export enum CAMERA_STATE {
  // 摄像头状态，1-接入，2-移除
  OPEN = 1,
  CLOSE = 2,
}
export enum DEVICE_TYPE {
  // 加入会议的端 0 PC; 1 ipad; 2 安卓; 3 iphone; 4 mac; 9 web;
  PC = 0,
  IPAD = 1,
  ANDROID = 2,
  IPHONE = 3,
  MAC = 4,
  WEB = 9,
}
export enum ROLE {
  // 用户角色,0-主持人，1-普通成员，2-游客
  HOST = 0,
  MEMBER = 1,
  GUEST = 2,
}
export enum MEMBER_STATUS {
  // 状态，0-已入会，1-待入会，2-呼叫中，3-被移除，4-取消呼叫，5-超时取消，6-已拒绝，10-离开，11-被踢出
  JOINED = 0,
  WAITING = 1,
  CALLING = 2,
  REMOVED = 3,
  CANCEL = 4,
  TIMEOUT = 5,
  REJECTED = 6,
  LEAVE = 10,
  KICK_OUT = 11,
}

export interface MemberStruct extends defs.api.ParticipatorInformationV3 {
  isOpenVideo?: boolean;
  // 业务id，由uid和deviceId组成
  mid: string;
  handupStatus: HandUpStatus;
  reaction: ReactionChangeChangeData;
}

export interface MemberStruct2 extends defs.api.ParticipatorInformationV3 {
  // 业务id，由uid和deviceId组成
  mid: string;
  // 加入会议的端 0 PC; 1 ipad; 2 安卓; 3 iphone; 4 mac; 9 web;
  deviceType: DEVICE_TYPE;
  // 成员头像地址
  memberAvatarUrl: string;
  // 成员头像 id
  memberAvatarId?: number;
  // 成员显示名称
  memberName: string;
  // 成员手机号
  phoneNumber: string;
  // 用户角色,0-主持人，1-普通成员，2-游客
  role: ROLE;
  // 状态，0-已入会，1-待入会，2-呼叫中，3-被移除，4-取消呼叫，5-超时取消，6-已拒绝，10-离开，11-被踢出
  status: MEMBER_STATUS;
  // popo账号是邮箱，游客用户是游客ID
  uid: string;
  // 云信uid
  yxUid: number;
  // 云信聊天室id
  yxImAccid: string;
  // 加入时间
  inTime: number;
  // app版本
  appVersion: string;
}

export interface InfoStruct extends defs.api.WebMeetingInformation {
  //   云信SDK - appkey
  appKey: string;
  // 取消全体静音人数上限
  audioOnTotal?: number;
  // 云信会议名，随机字符串
  channelName?: string;
  /**
   * @deprecated
   * @description 云信会议ID。可能出错，不用这个，用 rtc.cid
   */
  cid?: number;
  // 房间创建时间
  createtime?: number;
  // 房间结束时间
  destroytime?: number;
  // 关联Id
  externId?: string;
  // 会议ID
  meetingId: number;
  // 会议名称
  meetingName: string;
  members?: MemberStruct[];
  // 房间模式【1：双人、2：多人、3：日历】
  mode?: number;
  // 是否只能主持人邀请
  onlyOwnerInvite?: boolean;
  // 组织者uid，即主持人uid
  ownerUid?: string;
  // 加入房间默认是否静音
  quiet?: boolean;
  // 会议开始时间，日程会议才有该字段
  scheduleStartTim?: string;
  // 屏幕共享人，空字符串(‘’)表示没有共享人，否则是共享人的uid
  shareUid?: string;
  // 房间状态【1：初始状态，2：进行中，3：正常结束，4：异常结束，5：解散】
  status?: number;
  // 云信SDK - token，根据调用接口的用户获取
  token?: string;
  // 会议类型，1-音频，2-视频
  type?: number;
  // 是否允许web端入会
  webEnabled?: boolean;
  // web端入会链接
  webMeetingLink?: string;
  // 是否允许聊天室
  chatRoomEnabled: boolean;
  // 是否需要会议密码
  needPassword?: boolean;
}

export interface Question {
  doc: string;
  id: number;
  locale: number;
  type: number;
}

// 聊天室消息
export interface ChatMessage {
  chatroomId: string;
  flow: string;
  from: string;
  fromAvatar: string;
  fromClientType: string;
  fromCustom: string;
  fromNick: string;
  idClient: string;
  resend: boolean;
  status: string;
  text: string;
  type: ChatMessageType;
  time: number;
  userUpdateTime: number;
  custom: string | { nickname: string; uid: string; yxUid: string; avatarUrl: string };
}
export type ChatMessageObjectCustom = Exclude<ChatMessage['custom'], string>;

// 聊天室消息类型
export enum ChatMessageType {
  text = 'text',
  image = 'image',
  audio = 'audio',
  video = 'video',
  file = 'file',
  geo = 'geo',
  custom = 'custom',
  tip = 'tip',
  notification = 'notification',
}
export interface ParamsStruct {
  meetingId: string;
}
